/* eslint-disable max-len */

export const DEFAULT_STORE_ZIP = '30339';

export const SPEC_TITLE = 'Details';
export const APPLIANCE_CATEGORY = 'Appliance Category';
export const CATEGORY_ACCESSORY_MAPPING = {
  Refrigerator: 'Water Filter Replacement Model#'
};
export const NONE_COMPATIBLE = 'none';
export const KPF_MATCH = 'Model Compatibility';

export const FS_MAPPING = {
  PIP: 'enableCompatibleAccessoriesPIP',
  PAS: 'enableCompatibleAccessoriesPAS'
};
export const TARGET_MAPPING = {
  PIP: '_self',
  PAS: '_blank'
};

export const TOOL_TIP_TEXT_MAPPING = {
  Refrigerator: 'Your refrigerator will come with one water filter, however, water filters need to be replaced every 3 to 6 months, depending on consumption.'
};